// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_r2-5";
export var filledCircle = "_r2-4";
export var historyEntry = "_r2-3";
export var messageSideLeft = "_r2-1";
export var messageSideRight = "_r2-2";
export var orderTrackingCarouselWrapper = "_r2-6";
export var orderTrackingInfoContainer = "_r2-0";